import { IUserFirstSteps } from '@sdk/contracts';
import { useQuery, useQueryClient } from '@tanstack/react-query';

import { sdk } from '@/services';
import { useProfile } from '@/store';

const FirstStepsService = sdk.getService('UserFirstStepsService');

export const useMyFirstSteps = () => {
  const queryKey = ['first-steps'];
  const {
    roleCheck: { isStudent }
  } = useProfile();
  const queryClient = useQueryClient();
  const invalidate = () => queryClient.invalidateQueries({ queryKey });

  const {
    data: firstSteps,
    isLoading,
    error
  } = useQuery<IUserFirstSteps>({
    queryKey: ['first-steps'],
    queryFn: () => FirstStepsService.getMyFirstSteps(),
    enabled: isStudent
  });

  return {
    firstSteps,
    isLoading,
    error,
    invalidate
  };
};
